import { gql } from '@apollo/client';
import { TEvent } from '../../gqlQuery';

/**
 * This function will parameterize the graphql query since
 * if we * do not want to subscribe to a particular target
 * we have to remove 'target:' from the graphql
 * request parameters and remove '$target' from graphql field
 * parameters, hence the long ternary expressions.
 */
export function getOnCreateEventQuery(event?: TEvent) {
  return gql`
    subscription OnCreateEvent ${
      event
        ? `(
          ${event?.group ? '$group: EEventGroup' : ''}
          ${event?.target ? '$target: ELocation' : ''}
          ${event?.userId ? '$userId: Long' : ''}
          ${event?.businessId ? '$businessId: Long' : ''}
          ${event?.topicId ? '$topicId: String' : ''}
        )`
        : ''
    } {
      onCreateEvent ${
        event
          ? `(
          ${event?.group ? 'group: $group' : ''}
          ${event?.target ? 'target: $target' : ''}
          ${event?.userId ? 'userId: $userId' : ''}
          ${event?.businessId ? 'businessId: $businessId' : ''}
          ${event?.topicId ? 'topicId: $topicId' : ''}
        )`
          : ''
      } {
        id
        source
        target
        type
        group
        userId
        businessId
        topicId
        payload
      }
    }
  `;
}
